import React from 'react';
import { Layout, Menu, Button, Dropdown, Space } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { 
  ShoppingOutlined, 
  UserOutlined, 
  SearchOutlined,
  DashboardOutlined,
  LogoutOutlined,
  LoginOutlined
} from '@ant-design/icons';
import { userAPI } from '../utils/api';
import './Header.css';

const { Header: AntHeader } = Layout;

const AppHeader = ({ user, onLogout }) => {
  const navigate = useNavigate();
  
  const handleLogout = () => {
    userAPI.logout();
    if (onLogout) onLogout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'orders',
      icon: <ShoppingOutlined />,
      label: '我的订单',
      onClick: () => navigate('/my-orders')
    },
    ...(user?.role === 'admin' ? [{
      key: 'admin',
      icon: <DashboardOutlined />,
      label: '管理后台',
      onClick: () => navigate('/admin')
    }] : []),
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  const menuItems = [
    {
      key: 'home',
      label: <Link to="/">首页</Link>
    },
    {
      key: 'query',
      icon: <SearchOutlined />,
      label: <Link to="/order-query">订单查询</Link>
    }
  ];

  return (
    <AntHeader className="app-header">
      <div className="header-content">
        <div className="logo">
          <Link to="/">
            <ShoppingOutlined style={{ marginRight: 8 }} />
            发卡网
          </Link>
        </div>
        
        <Menu
          theme="dark"
          mode="horizontal"
          items={menuItems}
          className="header-menu"
        />

        <div className="header-actions">
          {user ? (
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
              <Button type="text" style={{ color: '#fff' }}>
                <Space>
                  <UserOutlined />
                  {user.username}
                </Space>
              </Button>
            </Dropdown>
          ) : (
            <Space>
              <Button type="text" icon={<LoginOutlined />} onClick={() => navigate('/login')} style={{ color: '#fff' }}>
                登录
              </Button>
              <Button type="primary" onClick={() => navigate('/register')}>
                注册
              </Button>
            </Space>
          )}
        </div>
      </div>
    </AntHeader>
  );
};

export default AppHeader;
